import { RETURN_TO } from '@User/LoginPage/constants'
import {
    QUOTE_ID,
    QUOTE_INVITE_TOKEN,
} from '@User/SignUpPage/components/constants'

import { SIGNUP_PATH } from '~/redux-modules/preferences'

const WHITELIST_HOSTNAMES = ['.fictiv.com', '.fictivlabs.com']

function isSafeReturnToParam(value: string): boolean {
    if (value.startsWith('/')) {
        return true
    }
    try {
        const url = new URL(value)

        const urlIsWhitelisted = WHITELIST_HOSTNAMES.some(hostName =>
            url.host.endsWith(hostName),
        )

        if (urlIsWhitelisted) {
            return true
        }
    } catch (e) {
        // skip, bad URL
    }
    return false
}

export const handleReturnTo = ({
    path,
    params,
    queryString,
    preferredRedirectPath,
}: {
    path: string
    params: Record<string, string | null>
    queryString?: string | null
    preferredRedirectPath?: string | null
}) => {
    const returnTo = params[RETURN_TO]
    const shouldRedirectToAcceptInvite = Boolean(
        params[QUOTE_INVITE_TOKEN] && params[QUOTE_ID] && !returnTo,
    )

    const originalQueryStr = (queryString || '').replace('?', '')
    const finalQueryStr = originalQueryStr
        .split('&')
        .filter(str => !str.startsWith(RETURN_TO))
        .join('&')
    let toPath

    if (returnTo && isSafeReturnToParam(returnTo)) {
        toPath = returnTo
    } else if (shouldRedirectToAcceptInvite) {
        toPath = `/pages/quotes/${params[QUOTE_ID]}/accept-invite`
    } else if (path === SIGNUP_PATH) {
        toPath = `/pages/quotes/upload`
    } else {
        toPath = preferredRedirectPath
    }

    const finalPath = `${toPath}${finalQueryStr ? `?${finalQueryStr}` : ''}`

    window.location.assign(finalPath)
}
